import React, { useEffect, useState } from "react";
import {
    AppBar,
    Box,
    Toolbar,
    Typography,
    Button,
    Container,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import icalllogo3 from '../Images/icalllogo3.png';

const Header = ({ data: propData }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [data, setData] = useState(null);

    console.log("========> header", data);

    useEffect(() => {
        const loadData = () => {
            const stored = localStorage.getItem("appData");
            if (stored) {
                setData(JSON.parse(stored));
            } else if (propData) {
                setData(propData);
            } else {
                setData({
                    appName: "iCall Phone Dialer & Contacts",
                    appIcon: null,
                });
            }
        };
        loadData();
        window.addEventListener('storage', loadData);
        const checkData = setInterval(loadData, 1000);

        return () => {
            window.removeEventListener('storage', loadData);
            clearInterval(checkData);
        };
    }, [propData]);


    useEffect(() => {
        const onscroll = () => {
            setScrolled(window.scrollY > 50);
        }
        window.addEventListener('scroll', onscroll);
        return () => window.removeEventListener('scroll', onscroll);
    }, []);

    const navItems = ["home", "about", "Features", "Privacy", "help"];
    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const capitalize = (word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

    const getPath = (item) => (item === "home" ? "/" : `/${item}`);

    const isActive = (item) => {
        const path = getPath(item);
        return location.pathname === path;
    };

    return (
        <>
            <AppBar
                position="fixed"
                color="default"
                elevation={0}
                sx={{
                    backgroundColor: scrolled ? "#fff" : "#fff",
                    paddingTop: "10px",
                    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                }}
            >
                <Container disableGutters maxWidth="xl">
                    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Box
                            component={Link}
                            to="/"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                textDecoration: 'none'
                            }}>
                            <Box
                                sx={{
                                    width: { md: 45, xs: 40 },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src={(data?.appIcon && data.appIcon !== "Not found") ? data.appIcon : icalllogo3}
                                    alt="iCall Logo"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = icalllogo3;
                                    }}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                    }}
                                />
                            </Box>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    color: scrolled ? '#212121d4' : '#212121d4',
                                    lineHeight: 1.2,
                                    fontFamily: `'Chivo', Arial, sans-serif`,
                                }}
                            >
                                {data?.appName && data.appName !== "Not found" ? (
                                    <>
                                        {data.appName.includes('&') ? (
                                            <>
                                                {data.appName.split('&')[0].trim()} &<br /> {data.appName.split('&')[1].trim()}
                                            </>
                                        ) : (
                                            data.appName
                                        )}
                                    </>
                                ) : (
                                    <>
                                        iCall Phone Dialer &<br /> Contacts
                                    </>
                                )}
                            </Typography>
                        </Box>
                        {!isMobile && (
                            <Box sx={{ display: "flex", gap: "15px" }}>
                                {navItems.map((item) => (
                                    <Link key={item} to={getPath(item)} style={{ textDecoration: "none" }}>
                                        <Button
                                            sx={{
                                                fontSize: "16px",
                                                color: isActive(item)
                                                    ? "rgb(64, 153, 247)"
                                                    : scrolled
                                                        ? '#212121d4'
                                                        : '#212121d4',
                                                fontWeight: isActive(item) ? 700 : 600,
                                                fontFamily: `'Chivo', Arial, sans-serif`,
                                                borderBottom: isActive(item) ? "2px solid rgb(64, 153, 247)" : "none",
                                                letterSpacing: '0.5px',
                                                lineHeight: 1.6,
                                                textTransform: "none",
                                                transition: "0.3s",
                                                "&:hover": {
                                                    color: "rgb(64, 153, 247)",
                                                    background: 'none',
                                                },

                                            }}
                                        >
                                            {capitalize(item === "home" ? "Home" : item.replace("-", " "))}
                                        </Button>
                                    </Link>
                                ))}
                                {!isMobile && (
                                    <Button
                                        component="a"
                                        href="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            padding: "8px 20px",
                                            color: "#fff",
                                            textTransform: "none",
                                            borderRadius: "10px",
                                            backgroundColor: "rgb(64, 153, 247)",
                                            fontWeight: 600,
                                            fontFamily: `'Chivo', Arial, sans-serif`,
                                            letterSpacing: ".0142857143em",
                                            fontSize: "16px",
                                            lineHeight: 1.5,
                                            transition: '1s',
                                            "&:hover": {
                                                backgroundColor: "#000",
                                            },
                                        }}
                                    >
                                        Download
                                    </Button>
                                )}
                            </Box>

                        )}
                        {isMobile && (
                            <IconButton sx={{
                                color: scrolled ? "#000" : "#000  ",
                            }} edge="end" onClick={toggleDrawer(true)}>
                                <MenuIcon />
                            </IconButton>
                        )}
                    </Toolbar>
                </Container>
            </AppBar>
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
                        <IconButton onClick={toggleDrawer(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
                        <Box
                            sx={{
                                width: 35,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src={(data?.appIcon && data.appIcon !== "Not found") ? data.appIcon : icalllogo3}
                                alt="iCall Logo"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    objectFit: 'contain',
                                    borderRadius: '5px'
                                }}
                            />
                        </Box>
                        <Typography
                            variant="body1"
                            sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                color: '#333',
                                lineHeight: 1.2,
                            }}
                        >
                            {data?.appName && data.appName !== "Not found" ? (
                                <>
                                    {data.appName.includes('&') ? (
                                        <>
                                            {data.appName.split('&')[0].trim()} &<br /> {data.appName.split('&')[1].trim()}
                                        </>
                                    ) : (
                                        data.appName
                                    )}
                                </>
                            ) : (
                                <>
                                    iCall Phone Dialer &<br /> Contacts
                                </>
                            )}
                        </Typography>
                    </Box>
                    <List>
                        {navItems.map((text) => (
                            <Link
                                key={text}
                                to={getPath(text)}
                                style={{ textDecoration: "none" }}
                            >
                                <ListItem
                                    onClick={() => setDrawerOpen(false)}
                                    sx={{
                                        textAlign: "center",
                                        paddingY: 2,
                                        color: isActive(text) ? "rgb(64, 153, 247)" : "#212121d4",
                                    }}
                                >
                                    <ListItemText
                                        primary={capitalize(text === "home" ? "Home" : text.replace("-", " "))}
                                    />
                                </ListItem>
                            </Link>
                        ))}
                        <ListItem
                            component="a"
                            href="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                width: "60%",
                                margin: "10px auto",
                                justifyContent: "center",
                                backgroundColor: "rgb(64, 153, 247)",
                                borderRadius: "20px",
                                padding: "10px",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#000",
                                },
                            }}
                        >
                            <ListItemText
                                primary="Download"
                                sx={{ textAlign: "center", color: "#fff", fontWeight: "bold" }}
                            />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default Header;